import React, { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import srcsets from "../components/srcsets.json"
import constants from "../constants"
import useIntersectionObserver from '../hooks/use-intersection-observer'
import { gsap } from "gsap"

const Picture = ({ filename, className, alt, animation, translate=0, duration=1, explore=false }) => {
  const [isVisible, setIsVisible] = useState(false)
  const parentEl = useRef()
  const wrapperEl = useRef()
  const containerEl = useRef()
  const anim = useRef()
  const set = srcsets.filter(s => s.name === filename)[0]
  const srcSet = set.images.map(s =>`${constants.IMG_PATH}images/${set.name}/${set.name},w_${s.width}.${set.ext} ${s.width}w`).join(",")
  const defaultImg = set.images[2]
  const defaultSrc = `${constants.IMG_PATH}images/${set.name}/${set.name},w_${defaultImg.width}.${set.ext}`
  const onLoadImage = () => {
    anim.current.play(0)
  }
  useIntersectionObserver({
    target: parentEl,
    rootMargin: `150px 0px 150px 0px`,
    threshold: 0,
    onIntersect: ([{ isIntersecting }]) => {
      if (isIntersecting) {
        if (!isVisible) setIsVisible(true)
      }
    }
  })
  useEffect(() => {
    anim.current = gsap.timeline()
    if (animation === `mask-left`) {
      anim.current.fromTo(wrapperEl.current, { clipPath: `inset(0px 0px 0px ${`calc(100%)`})` }, { clipPath: `inset(0px 0px 0px ${`calc(0%)`})`, duration, ease: `expo.out` }, 0.1)
      anim.current.fromTo(containerEl.current, { scale: 1.5, x: 100, }, { scale: 1, x: 0, duration, ease: `expo.out` }, 0.2)
    }
    if (animation === `mask-right`) {
      anim.current.fromTo(wrapperEl.current, { clipPath: `inset(0px ${`calc(100%)`} 0px 0px)` }, { clipPath: `inset(0px ${`calc(0%)`} 0px 0px)`, duration, ease: `expo.out` }, 0.1)
      anim.current.fromTo(containerEl.current, { scale: 1.5, x: -100 }, { scale: 1, x: 0, duration, ease: `expo.out` }, 0.2)
    }
    if (animation === `translate-y`) {
      anim.current.fromTo(parentEl.current, { opacity: 0 }, { opacity: 1, duration, ease: `expo.out` }, 0)
      anim.current.fromTo(wrapperEl.current, { y: translate }, { y: 0, duration, ease: `expo.out` }, 0.1)
    }
    if (animation === `translate-x`) {
      anim.current.fromTo(parentEl.current, { opacity: 0 }, { opacity: 1, duration, ease: `expo.out` }, 0)
      anim.current.fromTo(wrapperEl.current, { x: translate }, { x: 0, duration, ease: `expo.out` }, 0.1)
    }
    if (!animation) {
      anim.current.fromTo(parentEl.current, { opacity: 0 }, { opacity: 1, duration, ease: `expo.out` }, 0)
    }
    anim.current.pause(0)
  })
  return (
    <div ref={parentEl} className={`tw-w-full tw-h-auto tw-static`}>
      <div className={`${className} picture-position`}>
        <div className={`tw-relative`}>
          <svg className={`tw-w-full tw-h-auto`} viewBox={`0 0 ${set.width} ${set.height}`}>
            <rect width={`100%`} height={`100%`} style={{fill: `rgba(0,0,255, 0)` }} />
          </svg>
          <div
            ref={wrapperEl}
            className={`tw-absolute tw-top-0 tw-overflow-hidden tw-w-full`}
          >
            <div ref={containerEl}>
            {(isVisible && !explore) &&
              <img
                onLoad={onLoadImage}
                src={defaultSrc}
                srcSet={srcSet}
                className={`tw-w-full`}
                sizes={`(max-width: 1200px) 100vw, 1200px`}
                alt={alt || filename}
              />
            }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Picture.propTypes = {
  filename: PropTypes.string,
}

export default Picture
